import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import EditForm from 'components/forms/edit-form';
import Text from 'components/text/text';
import GridCol from 'components/grid/grid-col';
import GridRow from 'components/grid/grid-row';
import messages from './messages';

class AccountInfo extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.state = {
      'fields': [
        {
          'label': intl.formatMessage(messages.name_label),
          'value': 'Staniel McDaniels',
          'type': 'text',
          'name': 'name',
          'error': intl.formatMessage(messages.name_error)
        },
        {
          'label': intl.formatMessage(messages.gender_label),
          'value': 'male',
          'name': 'gender',
          'options': [
            {
              'description': intl.formatMessage(messages.gender_male_label),
              'path': ''
            },
            {
              'description': intl.formatMessage(messages.gender_female_label),
              'path': ''
            }
          ],
          'type': 'radio'
        },
        {
          'label': intl.formatMessage(messages.email_label),
          'value': 'test@example.com',
          'type': 'email',
          'name': 'email',
          'error': intl.formatMessage(messages.email_error)
        },
        {
          'label': intl.formatMessage(messages.password_label),
          'value': '',
          'type': 'password',
          'name': 'password',
          'error': intl.formatMessage(messages.password_error)
        }
      ]
    };

    this.title = intl.formatMessage(messages.account_heading);

    this.setUpHandlers();
  }

  setUpHandlers() {
    this.onFieldUpdate = this.handleFieldUpdate.bind(this);
  }

  handleFieldUpdate(fields) {
    // this.save().then ...
    this.updateFields();
  }

  /**
   * TODO: Return a promise after POST
   */
  save() {

  }

  /**
   * TODO: Update the fields state with confirmed data
   * after API success
   */
  updateFields(fields) {
    // this.setState({
    //   'fields':
    // });
  }

  render() {
    return (
      <section className="tier">
        <div className="set">
          <div className="set-hd">
            <Text
              align="center"
              type="xl"
              tag="h2"
              weight="light"
            >
              {this.title}
            </Text>
          </div>
          <div className="set-bd set-bd_mega">
            <GridRow>
              <GridCol desktop="6">
                <EditForm
                  fields={this.state.fields}
                  iconType="profile"
                  iconSize="lg"
                  onSave={this.onFieldUpdate}
                  ref={(form) => {this.form = form}}
                />
               </GridCol>
            </GridRow>
          </div>
        </div>
      </section>
    );
  }
}

export default injectIntl(AccountInfo);



// WEBPACK FOOTER //
// ./src/client/pages/profile/_account-info.jsx